<template>
  <router-view></router-view>
</template>

<script>
import { fixBodyPadding } from '@/utils/fixBodyPadding'

export default {
  name: 'App',
  data() {
    return {
      item: undefined,
      order: {
        count: 1,
        additionSelect: [],
        additionUSelect: []
      },
    }
  },
  mounted() {
    this.getUtmParams()
    window.buyItem = this.buyLandingItem
    window.leaveRequest = this.openRequestModal
  },

  computed: {
    basked() {
      return this.$store.state.busked
    },
    options_list() {
      return this.$store.getters.getOptions
    },
  },
  methods: {
    async getUtmParams() {
      // console.log(window.location)
      const searchParams = new URLSearchParams(decodeURI(window.location.search.replaceAll("&amp%3B", "&")));
      // if (localStorage.getItem("utmParams")) {
      //   return
      // }

      // Определяем UTM-метки, которые нас интересуют
      const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
      const utmData = {};

      // Проверяем, есть ли UTM-метки в параметрах маршрута
      utmParams.forEach(param => {
        if (searchParams.has(param)) {
          utmData[param] = searchParams.get(param);
        }
      });

      // Если хотя бы одна метка есть, сохраняем их в localStorage
      if (Object.keys(utmData).length > 0) {
        localStorage.setItem('utmParams', JSON.stringify(utmData));
      }
    },

    buy() {
      let idx = -1;
      idx = this.basked.findIndex(i => i.id === this.item.id);
      if (idx > -1) {
        // this.basked[idx].count += this.order.count;
        this.$store.commit(
          'replaceBuskedIndex',
          { index: idx, value: JSON.parse(JSON.stringify(Object.assign({}, this.order, this.item))) }
        );
      } else {
        let item = JSON.parse(JSON.stringify(Object.assign({}, this.order, this.item)))
        this.$store.commit('addToBasked', item);
        this.$AddToCart(item)
      }
      this.toggleBusked()

    },

    toggleBusked() {
      fixBodyPadding();

      this.$store.commit('setBuskedOpen', !this.isBuskedOpen)

      this.$store.commit('setSearchOpen', false);
      this.$store.commit('setReadMoreOpen', false)

      window.$('.overlay-menu').removeClass('active');
      window.$('.open-nav').removeClass('is-visible');
      window.$('.show-menu-btn').removeClass('open');

      window.$('.personal-area-modal-wrapper-bg').removeClass('is-visible');
      window.$('.personal_area-sidebar').removeClass('opened');
      window.$('.login-trigger-item').removeClass('active');


      window.$('.cart-modal-wrapper-bg').toggleClass('is-visible');
      window.$('.quick-card-sticker-li').toggleClass('active');
      window.$('#quick_cart').toggleClass('opened');

      window.$('body').toggleClass('no-scroll');
    },

    async fetchLandingItem(id) {
      // this.group = [];
      try {
        const response = await fetch(`/public/item/${id}`);
        const data = await response.json();

        if (data.result) {
          this.item = data.result;
          this.$ViewItem(this.item);
          // await this.getUpsaleItems();
        }

        // if (data.group) {
        //   this.group = data.group;
        // }

        if (data.error === 'not found') {
          this.$router.push({ name: 'NotFound' });
          return;
        }

        // if (item && item.advanced) {
        //   const title = item.advanced.meta_title || this.$dynamic(item, item.title, 'title');
        //   document.querySelector('title').innerText = title;
        //   document.querySelector('meta[property="og:title"]').setAttribute('content', title);

        //   const description = item.advanced.meta_description || '';
        //   document.querySelector('meta[name="description"]').setAttribute('content', description);
        //   document.querySelector('meta[property="og:description"]').setAttribute('content', description);

        //   const image = item.preview ? `${window.location.protocol}//${window.location.host}${item.preview}` : '';
        //   document.querySelector('meta[property="og:image"]').setAttribute('content', image);
        // }
      } catch (error) {
        console.error("Error fetching item:", error);
      }
    },
    adaptOrderDetails(data) {
      if (data.count) {
        this.order.count = data.count;
      }
      if (!this.order.additionSelect) {
        this.order.additionSelect = []; // Инициализация, если массив еще не создан
      }

      if (data.selectedOptions && Array.isArray(data.selectedOptions) && data.selectedOptions.length > 0) {
        // Список ID, которые должны быть в additionSelect
        const validIds = [];

        // Пройтись по выбранным опциям
        data.selectedOptions.forEach((selectedOption) => {
          // Найти группу опций в общем списке
          const matchingOption = Object.values(this.options_list).find(
            (optionGroup) => optionGroup.option.toLowerCase().trim() === selectedOption.optionTitle.toLowerCase().trim()
          );

          if (matchingOption) {
            // Пройтись по значениям внутри найденной группы
            matchingOption.list.forEach((item) => {
              if (selectedOption.values.includes(item.name)) {
                // Проверить, есть ли уже этот элемент в additionSelect
                const alreadyAdded = this.order.additionSelect.some(
                  (addedItem) => addedItem.id === item.id
                );

                if (!alreadyAdded) {
                  this.order.additionSelect.push(item);
                }

                // Добавить в список валидных ID
                validIds.push(item.id);
              }
            });
          }
        });

        // Удалить из additionSelect элементы, которых нет в validIds
        this.order.additionSelect = this.order.additionSelect.filter((item) =>
          validIds.includes(item.id)
        );
      } else {
        // Если selectedOptions пуст, очищаем additionSelect
        this.order.additionSelect = [];
      }

      console.log("this.order", this.order);
    },

    async buyLandingItem(id, orderDetails) {
      await this.fetchLandingItem(id);
      this.adaptOrderDetails(orderDetails);
      this.buy();
    },

    async openRequestModal(itemId) {
      await this.fetchLandingItem(itemId);
      this.$store.commit(
        'setLandingRequestItem', this.item);

      // Дождаться рендеринга компонента
      this.$nextTick(() => {
        fixBodyPadding();

        window.$('.service-request-modal-wrapper-bg').addClass('is-visible');
        window.$('body').addClass('no-scroll');
      });
    },
  }
}
</script>